module.exports = __webpack_public_path__ + "img/de.2c6fe6d8.png";